import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en/translation.json';
import fr from './fr/translation.json';
import ar from './ar/translation.json';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
  ar: { translation: ar }
};

const savedLanguage = localStorage.getItem('appLanguage');
const defaultLanguage = savedLanguage ? savedLanguage.toLowerCase() : 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    lng: defaultLanguage,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
